'use es6';

export const LOCATOR_DIV_ID = 'hs-insert-location';

// Cache to keep track of parsed wrapping html. It stores:
// - The wrapping html string as a key to compare
// - The parsed wrapping html
// - the index of the element that contains the column in the elementArray
export const WRAPPING_HTML_CACHE = {};
export const renderModuleWithWrappingHTML = (moduleName, moduleElement, wrappingHtmlString, parentElementToAppendModuleTo) => {
  // Check cache for prehydrated node template, if it's not there create it
  if (!WRAPPING_HTML_CACHE[moduleName] || WRAPPING_HTML_CACHE[moduleName].wrappingHtmlString !== wrappingHtmlString) {
    // Parse the string into html nodes, leaving a place holder div
    // where the wrapper hubl indicated the module html should go
    const updatedWrappingHtml = wrappingHtmlString.replace(/\{\{\s*html\s*\}\}/, `<div id="${LOCATOR_DIV_ID}"></div>`);
    // Hydrate the html string in a dom tree
    const markupContainer = document.createElement('div');
    markupContainer.insertAdjacentHTML('afterbegin', updatedWrappingHtml);
    WRAPPING_HTML_CACHE[moduleName] = {
      wrapperHtmlDomNode: markupContainer,
      wrappingHtmlString
    };
  }
  // Grab a copy of the wrapping html tree of nodes
  const cachedWrapperHtmlNode = WRAPPING_HTML_CACHE[moduleName].wrapperHtmlDomNode.cloneNode(true);
  const tempPlaceholderDiv = cachedWrapperHtmlNode.querySelector(`#${LOCATOR_DIV_ID}`);
  // Put the actual module element after the place holder, then kill the placeholder
  tempPlaceholderDiv.insertAdjacentElement('afterend', moduleElement);
  tempPlaceholderDiv.parentNode.removeChild(tempPlaceholderDiv);

  // Now copy all the child nodes off this wrapperHtml tree and onto the actual parent element
  while (cachedWrapperHtmlNode.firstChild) {
    const childNode = cachedWrapperHtmlNode.firstChild;
    parentElementToAppendModuleTo.appendChild(childNode);
  }
};